import { Box, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import EditForm from '../../components/EditForm/EditForm';
import EditFormContent from '../../components/EditForm/EditFormContent';
import EditFormField from '../../components/EditForm/EditFormField';
import EditFormHeader from '../../components/EditForm/EditFormHeader';
import WhatsappDialog from '../../components/WhatsappDialog';
import getDomain from '../../helpers/domains';

const Step1 = ({ control, logoutButton, ...otherProps }) => {
  const [enterpriseName, enterpriseGender] = useWatch({
    control,
    name: ['enterpriseName', 'enterpriseGender'],
  });
  const exampleText =
    enterpriseGender && enterpriseName
      ? `Olá aqui é o Agente Digital d${enterpriseGender} *${enterpriseName}*.`
      : 'Olá aqui é o Agente Digital _<preencher os campos acima>_';
  const content = {
    contactName: 'Agente Digital',
    items: [
      {
        direction: 'in',
        type: 'text',
        text: exampleText,
        timestamp: Date.now(),
        accent: true,
      },
      {
        direction: 'in',
        type: 'text',
        text: 'Como vai, tudo bem?',
        timestamp: Date.now(),
      },
      {
        direction: 'out',
        type: 'text',
        text: 'Boa noite!',
        timestamp: Date.now(),
      },
      {
        direction: 'out',
        type: 'text',
        text: 'Estou bem, obrigado!',
        timestamp: Date.now(),
      },
    ],
  };
  return (
    <EditForm {...otherProps}>
      <EditFormHeader
        title="Qual é o nome da empresa ?"
        actions={logoutButton}
      />
      <EditFormContent>
        <Typography variant="body2" color="textSecondary" component="p">
          N{getDomain(window.location.hostname).gender}{' '}
          {getDomain(window.location.hostname).name} a conta é associada a uma
          empresa. Este será o nome que vai aparecer quando o agente digital se
          apresentar.
        </Typography>
        <Box marginTop={2}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <EditFormField
                field={{
                  name: 'enterpriseName',
                  label: 'Nome',
                  type: 'text',
                }}
                defaultValue={''}
                control={control}
                rules={{
                  required: 'Obrigatório',
                  minLength: {
                    value: 3,
                    message: 'Digite um nome válido',
                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <EditFormField
                field={{
                  name: 'enterpriseGender',
                  label: 'Gênero',
                  type: 'select',
                  options: [
                    { value: 'a', label: 'Feminino' },
                    { value: 'o', label: 'Masculino' },
                  ],
                }}
                defaultValue={''}
                control={control}
                rules={{
                  required: 'Campo obrigatório',
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" color="textSecondary" component="p">
                Exemplo:
              </Typography>
              <WhatsappDialog content={content} />
            </Grid>
          </Grid>
        </Box>
      </EditFormContent>
    </EditForm>
  );
};
Step1.propTypes = {
  control: PropTypes.object,
  logoutButton: PropTypes.node,
};
export default Step1;
